export default (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  content: {
    marginBottom: theme.spacing(4),
    width: '100%',
  },
  question: {
    width: '100%',
  },
  moreOptionsIndicator: {
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.standard,
    }),
    opacity: 0.75,
    pointerEvents: 'none',
    position: 'fixed',
    bottom: 130,
    right: theme.spacing(2),
  },
  moreOptionsIndicatorHidden: {
    opacity: 0,
  },
});
